import styles from "./CommonCardFeatureSegment.module.css";
import { FiEye } from "react-icons/fi";

interface Props {
  name: string;
  description: string;
  handleClick: (id: string, name?: string, additionalItem?: any) => void;
  btnTitle: string;
  id: string;
  type?: string;
  enabled?: boolean;
  dynamic?: boolean;
}

const CommonCardFeatureSegment = (props: Props) => {
  const {
    id,
    name,
    description,
    handleClick,
    btnTitle,
    type,
    enabled,
    dynamic,
  } = props;

  return (
    <div className={styles.segmentCard}>
      <div className={styles.segmentHeader}>
        <div className={styles.segmentInfo}>
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
        <button
          onClick={() => handleClick(id, name, { enabled, dynamic })}
          className={styles.viewButton}
        >
          <FiEye />
          {btnTitle}
        </button>
      </div>
      {type && <div className={styles.typePill}>{type}</div>}
    </div>
  );
};

export default CommonCardFeatureSegment;
